/**
 * Attivazione: aggiungere BiIntegratedModule a modules.active in applications/app (vedi App.js).
 * Opzionale: configs/config → modules['bis/biIntegrated'] per tableConfig / filtri persistenti.
 */
import * as Views from "./views";

const Module = {
    name: "biIntegrated",
    defaultRoutePath: "/bis/biIntegrated",
    menuItemScope: "bis",
    menuItemName: "biIntegrated",

    routes: [
        {
            path: "/bis/biIntegrated",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
            ],
        },
    ],
    drawerRoutes: [],
};

export default Module;
